import React from 'react';
import ReportScore from './index';
import ReportScoreTeamSelect from '../report-score-team-select/index';
import {usePersistentQueryParam} from "../hooks";
import {gql, useQuery} from "@apollo/client";
import {useQueryParam} from "../routerHooks";
import {Spinner} from "@blueprintjs/core";

const GET_TEAM_BY_GUID = gql`
    query($teamId: UUID!) {
        teamByGUID(guid: $teamId) {
            id
        }
    }
`

export default () => {
  // const [teamId, setTeamId, clearTeamId] = usePersistentQueryParam('t')
  const [teamGuid, ] = useQueryParam('t')

  const { loading, data, error } = useQuery(GET_TEAM_BY_GUID, {
    variables: {
      teamId: teamGuid
    }
  })

  if (loading) return <Spinner />

  const teamId = data?.teamByGUID?.id

  if (teamId) {
    return <ReportScore teamId={teamId} clearTeamId={() => {}} />
  } else {
    return <h1 style={{textAlign: 'center'}}>Please use your team portal to report a score</h1>

    /*
    return <ReportScoreTeamSelect
      setTeamId={setTeamId}
    />
    */
  }
}
